var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 5.71384C1.33203 4.27717 1.33203 3.55917 1.7227 3.1125C2.11336 2.66584 2.74136 2.6665 3.9987 2.6665H11.9987C13.256 2.6665 13.884 2.6665 14.2747 3.11317C14.6654 3.5585 14.6654 4.2765 14.6654 5.71317V10.2852C14.6654 11.7218 14.6654 12.4398 14.2747 12.8865C13.884 13.3332 13.256 13.3332 11.9987 13.3332H3.9987C2.74136 13.3332 2.11336 13.3332 1.7227 12.8865C1.33203 12.4412 1.33203 11.7232 1.33203 10.2865V5.71384Z",
    stroke: "#767A85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9974 9.33317C8.73378 9.33317 9.33073 8.73622 9.33073 7.99984C9.33073 7.26346 8.73378 6.6665 7.9974 6.6665C7.26102 6.6665 6.66406 7.26346 6.66406 7.99984C6.66406 8.73622 7.26102 9.33317 7.9974 9.33317Z",
    stroke: "#767A85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 6.66634V3.33301M7.9987 9.33301V12.6663M14.6654 5.99967H12.9987C12.8219 5.99967 12.6523 6.06991 12.5273 6.19494C12.4023 6.31996 12.332 6.48953 12.332 6.66634V9.33301C12.332 9.50982 12.4023 9.67939 12.5273 9.80441C12.6523 9.92944 12.8219 9.99967 12.9987 9.99967H14.6654M1.33203 5.99967H2.9987C3.17551 5.99967 3.34508 6.06991 3.4701 6.19494C3.59513 6.31996 3.66536 6.48953 3.66536 6.66634V9.33301C3.66536 9.50982 3.59513 9.67939 3.4701 9.80441C3.34508 9.92944 3.17551 9.99967 2.9987 9.99967H1.33203",
    stroke: "#767A85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitch);
export default __webpack_public_path__ + "static/media/pitch.ddc1ef17576def72353d2a3ef18afcda.svg";
export { ForwardRef as ReactComponent };